/* eslint-disable */
import React, { useEffect, Suspense } from 'react'

import { useNavigate, useLoaderData, Link, useParams, Await, json } from "react-router-dom";
import { 
    SegmentedControl
} from '@yapstudios/yap-content-builder'

import { Loading } from '../Loading.js'

// Styling
import styled from 'styled-components'

import { Renderer } from "../YapDesigner/YapUI/Renderer/Renderer.js";
import { ComponentInfo } from '../YapDesigner/ComponentInfo.js';
import { useProjectDataAsync, useProjectData } from '../YapDesigner/Backend.js';
import { loadTypes, useTypes , useTypesAsync } from "../AppData.js";
import { viewForComponentName , assetForKey, findView, useLinkUI, ItemType } from '../YapDesigner/YapDesigner.js';
import { useAppMirrorPreview }  from '../AppMirror.js'
import JSON5 from 'json5'
import { useJSRuntime } from '../YapDesigner/YapUI/useJSRuntime.js'


export async function yapMirrorLoader({ params }) {

    // temp fix for path
    const idQuery = new URL(window.location).searchParams.get('id');

    // temp fix for path
    const mirrorId   = params['id'] ?? idQuery;

    //const { types } = useTypes(instanceId);
    const { components, current, preview, frame } = await useAppMirrorPreview(mirrorId);

    return { components: components, previewIndex: preview, screen: current, canChangePreviews: false }
}


export function YapPreview({ components, screen, projectId, updateTime, previewIndex, canChangePreviews }) {

    const [userPreviewIndex, setUserPreviewIndex] = React.useState(0);  

    const [lastUpdateTime, setLastUpdateTime] = React.useState(false)
    
    const environment = {   
        'environment.preview' : 'view',
        'preview' : 'view'
    }

    const navigate = useNavigate()

    const runtime = useJSRuntime()

    /**
    * Register views with the runtime when the project is loaded
    */
    useEffect(() => {   
        if (runtime == null) { 
            console.log('no runtime')
            return 
        } 

        console.log('Runtime: Registering views ', components, projectId)

        runtime.reset()

        let componentTypes = {}

        const allItems = components//[...data.packageTypes, ...data.types]
        allItems.filter(item => item.type == ItemType.yapui || item.type == ItemType.composer).forEach((item) => {
            let name = item.name
            
            // Remove spaces
            name = name.replace(/\s/g, '')

            componentTypes[name] = item.content
        })
        runtime.registerComponents(componentTypes)

        setLastUpdateTime((updateTime ?? new Date()).toString())

    }, [projectId, components.length, (updateTime ?? new Date()).toString() ])

    // Wait for both to load.
    if (screen == null || components == null || components.length == 0) { 
        return null 
    }
    
    /**
     * Callback that resolves asset for a specific key
     */
    const assetCallback = (key, componentName, parentNames) => {
        for (var parentName of parentNames) {
            let asset = assetForKey(key, parentName, components)
            if (asset) { return asset }
        } 
        return assetForKey(key, componentName, components)
    }

     /**
     * Callback that gets called when a route is triggered
     */
    const routeCallback = (name) => {
        if (name == '#back' && window.location.href.indexOf('#ui=') > -1) {
            navigate(-1)
            return
        }

        // JSON
        if (typeof name == 'object') {  
            let encode = JSON5.stringify(name)
            // encode to base 64
            let base64 = btoa(encode)
            navigate(`#ui=${base64}`)
            return encode
        }
    }
    const linkUI = useLinkUI()

    const currentPreviewIndex = previewIndex != null ? previewIndex : userPreviewIndex

    /**
     * If screen has a composer, use that frame's preview.
     */
    var frame = screen.frame
    if (screen.composerFrame) {
        let item = findView(screen.composerFrame, components)
        if (item) {
            frame = item.frame
        }
    }

    console.log('YapPreview: render ', updateTime)

    const renderer = <Renderer runtime={runtime}
                                updateEveryRender={true}
                            //    yapui={linkUI ?? screen.body ?? screen.json} 
                               routeCallback={routeCallback}
                               getAsset={assetCallback}
                               componentName={screen.name}
                               frame={frame} 
                               ignorePreview={linkUI != null}
                               previews={screen.previews}
                               previewIndex={currentPreviewIndex}
                               environment={environment} />


    const infoIcon = (
        <svg aria-hidden="true" width="19" height="18" viewBox="0 0 19 18" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path  style={{"fill": "var(--content-builder-ui-tint-color)"}} fill="#e3e3e3" d="M9.75146 17.7412C8.55062 17.7412 7.42171 17.5116 6.36475 17.0523C5.30778 16.5985 4.37533 15.9676 3.56738 15.1597C2.75944 14.3573 2.12581 13.4276 1.6665 12.3706C1.21273 11.3137 0.98584 10.182 0.98584 8.97562C0.98584 7.77478 1.21273 6.64587 1.6665 5.58891C2.12581 4.53194 2.75667 3.59948 3.55908 2.79154C4.36702 1.9836 5.29948 1.35274 6.35645 0.898964C7.41895 0.439654 8.55062 0.209999 9.75146 0.209999C10.9523 0.209999 12.0812 0.439654 13.1382 0.898964C14.2007 1.35274 15.1331 1.9836 15.9355 2.79154C16.7435 3.59948 17.3771 4.53194 17.8364 5.58891C18.2957 6.64587 18.5254 7.77478 18.5254 8.97562C18.5254 10.182 18.2957 11.3137 17.8364 12.3706C17.3771 13.4276 16.7435 14.3573 15.9355 15.1597C15.1331 15.9676 14.2035 16.5985 13.1465 17.0523C12.0895 17.5116 10.9578 17.7412 9.75146 17.7412ZM9.75146 15.5581C10.6646 15.5581 11.5195 15.3866 12.3164 15.0435C13.1133 14.7059 13.8133 14.2383 14.4165 13.6407C15.0197 13.0375 15.4901 12.3374 15.8276 11.5406C16.1707 10.7437 16.3423 9.88871 16.3423 8.97562C16.3423 8.06254 16.1707 7.21032 15.8276 6.41898C15.4845 5.62211 15.0114 4.92208 14.4082 4.31889C13.8105 3.7157 13.1133 3.24532 12.3164 2.90775C11.5195 2.56465 10.6646 2.3931 9.75146 2.3931C8.83838 2.3931 7.9834 2.56465 7.18652 2.90775C6.39518 3.24532 5.69792 3.7157 5.09473 4.31889C4.49154 4.92208 4.02116 5.62211 3.68359 6.41898C3.34603 7.21032 3.17725 8.06254 3.17725 8.97562C3.17725 9.88871 3.34603 10.7437 3.68359 11.5406C4.02116 12.3374 4.49154 13.0375 5.09473 13.6407C5.69792 14.2383 6.39795 14.7059 7.19482 15.0435C7.9917 15.3866 8.84391 15.5581 9.75146 15.5581ZM8.29883 13.3916C8.09408 13.3916 7.91976 13.3252 7.77588 13.1924C7.632 13.0541 7.56006 12.8798 7.56006 12.6695C7.56006 12.4647 7.632 12.2959 7.77588 12.1631C7.91976 12.0248 8.09408 11.9556 8.29883 11.9556H9.21191V9.07523H8.45654C8.24626 9.07523 8.06917 9.00883 7.92529 8.87601C7.78141 8.7432 7.70947 8.56889 7.70947 8.35307C7.70947 8.15385 7.78141 7.98506 7.92529 7.84672C8.06917 7.70837 8.24626 7.6392 8.45654 7.6392H10.0254C10.291 7.6392 10.493 7.72497 10.6313 7.89652C10.7697 8.06254 10.8389 8.28666 10.8389 8.56889V11.9556H11.5776C11.7879 11.9556 11.9622 12.0248 12.1006 12.1631C12.2445 12.2959 12.3164 12.4647 12.3164 12.6695C12.3164 12.8798 12.2445 13.0541 12.1006 13.1924C11.9622 13.3252 11.7879 13.3916 11.5776 13.3916H8.29883ZM9.74316 6.51859C9.41667 6.51859 9.13444 6.40238 8.89648 6.16996C8.66406 5.932 8.54785 5.65254 8.54785 5.33158C8.54785 4.99402 8.66406 4.70902 8.89648 4.4766C9.13444 4.24418 9.41667 4.12797 9.74316 4.12797C10.0752 4.12797 10.3547 4.24418 10.5815 4.4766C10.814 4.70902 10.9302 4.99402 10.9302 5.33158C10.9302 5.65254 10.814 5.932 10.5815 6.16996C10.3547 6.40238 10.0752 6.51859 9.74316 6.51859Z" />
        </svg>
    )

    const infoMenu = screen ? (
        <InfoPanel className="hide-mobile">
            <ComponentInfo component={screen}  previewStates={canChangePreviews ? screen.previews : null} previewIndex={currentPreviewIndex} setPreviewIndex={setUserPreviewIndex} canChangePreviews={canChangePreviews}/>
        </InfoPanel>
    ) : null

    let content = null
    if (screen.type == 'folder') {
        content = 'Folder'
    } else {
        content = <YapPreviewContent renderer={renderer} infoMenu={infoMenu} />
    }

    return content
}

export function YapPreviewContent({ renderer, infoMenu }) {

    return (
        <PreviewContent>            
            {renderer}
            {infoMenu}
        </PreviewContent>
    );
}


const InfoPanel = styled.div`
    position: absolute;
    top: 32px;
    left: 32px;
    width: 300px;
    border-radius: 15px;
    background: white;
    box-shadow: 0px 10px 25px rgba(0, 0, 0, 0.12);
`

const PreviewPage = styled.div`
    width: 100vw;
    height: 100vh;
`

const PreviewContent = styled.div`
    position: relative;
    display: flex;
    flex-direction: column;
    justify-items: center;
    justify-content: center;
    align-items: center;
    alig-content: center;
    height: 100vh;
    width: 100vw;
    
    .has-toolbar {
        padding-top: 15px;
    }
`